'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function (_React$Component) {
    _inherits(HeaderButton, _React$Component);

    function HeaderButton(props) {
        _classCallCheck(this, HeaderButton);

        var _this = _possibleConstructorReturn(this, (HeaderButton.__proto__ || Object.getPrototypeOf(HeaderButton)).call(this, props));

        _this.buttonName = 'Button';
        _this.buttonTextName = 'ButtonText';
        return _this;
    }

    _createClass(HeaderButton, [{
        key: 'getButtonStyle',
        value: function getButtonStyle() {
            var buttonStyle = { background: this.props.colors[this.buttonName] };
            if (this.props.isComponentOutlined(this.props, this.buttonName)) {
                buttonStyle = this.outline(buttonStyle);
            }
            return buttonStyle;
        }
    }, {
        key: 'getButtonTextStyle',
        value: function getButtonTextStyle() {
            var buttonTextStyle = { color: this.props.colors[this.buttonTextName] };
            if (this.props.isComponentOutlined(this.props, this.buttonTextName)) {
                buttonTextStyle = this.outline(buttonTextStyle);
            }
            return buttonTextStyle;
        }
    }, {
        key: 'outline',
        value: function outline(style) {
            return Object.assign(style, this.props.outlineStyle);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var buttonStyle = this.getButtonStyle();
            var buttonTextStyle = this.getButtonTextStyle();
            return _react2['default'].createElement(
                'button',
                { onClick: function onClick(event) {
                        return _this2.props.handleClick(event, _this2.buttonName);
                    },
                    style: buttonStyle
                },
                _react2['default'].createElement(
                    'span',
                    { onClick: function onClick(event) {
                            return _this2.props.handleClick(event, _this2.buttonTextName);
                        },
                        style: buttonTextStyle
                    },
                    'BUTTON TEXT'
                )
            );
        }
    }]);

    return HeaderButton;
}(_react2['default'].Component);


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/white-labeling/header-button.jsx
 ** module id = 1280
 ** module chunks = 0
 **/